import 'angular';
import * as _ from 'lodash-es';

import '../approvalLevelModal/ApprovalLevelsModalController';
import './ApprovalDetailsService';

import {RootScope} from "../../types/angular-types";
import {FolderMetadata} from "../../types/FolderMetadata";
import {DocMetadata} from "../../types/DocMetadata";
import {ApprovalService, ApprovalLevelConfig, ApprovalDetailsService, ApprovalResource, ApprovalApprover, ApprovalOperationName, ApprovalInfo, ApprovalDetailsServiceMode, ApprovalState} from "../approvals-types";
import {IApprovalUtils} from "../ApprovalUtils"
import AppConstants from "../../gorillaboy/AppConstants";
import SignalProvider from '../../gorillaboy/SignalProvider';

NewApprovalRequestPanelControllerFn.$inject = ['$scope', '$rootScope', '$uibModal', '$translate', '$q',
    'ApprovalService', 'ApprovalUtils', 'MessageManager', 'ApprovalDetailsService', '$location'];

angular.module("GorillaBoy.Approvals")
.controller('NewApprovalRequestPanelController', NewApprovalRequestPanelControllerFn);

interface scope extends RootScope {
    // View model
    approvalResources: ApprovalResource[];
    formData: {
        title: string,
        description: string
    };
    loading: boolean;
    panelMode: ApprovalDetailsServiceMode;

    // Methods
    removeApprovalResource: (resource: ApprovalResource) => void;
    saveTitle: () => void;
    saveDescription: () => void;
    getResourceIcon: (resource: ApprovalResource) => string;
    atLeastOneFileIsAttached: (resources: ApprovalResource[]) => boolean;
    atLeastOneFolderIsAttached: (resources: ApprovalResource[]) => boolean;
    getAttachedFileText: (resources: ApprovalResource[]) => string;
    getAttachedFolderText: (resources: ApprovalResource[]) => string;
    createApprovalRequestClickHandler: () => void;
    updateApprovalRequestClickHandler: () => void;
    showUpdateButton: () => boolean;
    showCreateButton: () => boolean;
    isResourceModificationAllowed: () => boolean;
    isLevelConfigEmpty: () => boolean;
};

function NewApprovalRequestPanelControllerFn($scope: scope, $rootScope: RootScope, $uibModal: any, $translate: ng.translate.ITranslateService, $q: ng.IQService,
     ApprovalService: ApprovalService, ApprovalUtils:IApprovalUtils, MessageManager: any,
     ApprovalDetailsService: ApprovalDetailsService, $location: ng.ILocationService) {

    //////////////////////////////////
    // INITIALIZATION
    //////////////////////////////////
    initScope();

    //////////////////////////////////
    // METHODS
    //////////////////////////////////
    $scope.removeApprovalResource = (resource: ApprovalResource) => {
        $scope.approvalResources = ApprovalDetailsService.deleteApprovalResourceByUri(resource.ResourceUri);
    };

    $scope.saveTitle = () => {
        let currentApproval = ApprovalDetailsService.getApproval();
        currentApproval.Title = $scope.formData.title;
        ApprovalDetailsService.setApproval(currentApproval);
    };

    $scope.saveDescription = () => {
        let currentApproval = ApprovalDetailsService.getApproval();
        currentApproval.Description = $scope.formData.description;
        ApprovalDetailsService.setApproval(currentApproval);
    };

    $scope.isCreateButtonDisabled = () => {
        let validTitle = !!$scope.formData.title;
        let atLeastOneLevel = ApprovalDetailsService.getApprovalLevelConfigs().length > 0;
        let atLeastOneResource = ApprovalDetailsService.getApprovalResources().length > 0;
        return !(validTitle && atLeastOneLevel && atLeastOneResource);
    };
    $scope.getCreateButtonPopoverText = () => {
        let validTitle = !!$scope.formData.title;
        let atLeastOneLevel = ApprovalDetailsService.getApprovalLevelConfigs().length > 0;
        let atLeastOneResource = ApprovalDetailsService.getApprovalResources().length > 0;
        const keyPrefix = 'APPROVALS.FILE_BROWSER_PANEL.CREATE_BUTTON_TOOLTIPS.';
        if (!validTitle) {
            return $translate.instant(keyPrefix + 'ADD_TITLE');
        }
        if (!atLeastOneLevel) {
            return $translate.instant(keyPrefix + 'ADD_PEOPLE');
        }
        if (!atLeastOneResource) {
            return $translate.instant(keyPrefix + 'ADD_FILES');
        }
        return $translate.instant(keyPrefix + 'VALIDATION_PASSED')
    };
    
    $scope.showUpdateButton = () => {
        return $scope.panelMode === ApprovalDetailsServiceMode.EDIT;
    };

    $scope.showCreateButton = () => {
        return $scope.panelMode === ApprovalDetailsServiceMode.CREATE;
    }

    $scope.createApprovalRequestClickHandler = () => {
        $scope.loading = true;
        let approvalInfo: ApprovalInfo = null;
        ApprovalService.CreateApproval($scope.formData.title, $scope.formData.description, ApprovalDetailsService.getApprovalLevelConfigs())
        .then((response) => {
            approvalInfo = response.data.ApprovalInfo;
            return ApprovalService.CreateApprovalResources(approvalInfo.Id, ApprovalDetailsService.getApprovalResources());
        })
        .then((response) => {
            let approvers = [];
            ApprovalDetailsService.getApprovalLevelConfigs().forEach((levelConfig) => {
                approvers = approvers.concat(levelConfig.approvers);
            })
            return ApprovalService.CreateApprovers(approvalInfo.Id, approvers);
        })
        .then(() => {
            return ApprovalService.UpdateApproval(approvalInfo.Id, ApprovalOperationName.PUBLISH, null);
        })
        .then(() => {
            ApprovalDetailsService.initService();
            initScope();
            $rootScope.toggleRightSidebar();
            $location.url("/yourApprovalRequests");
            MessageManager.addSuccessMessage($translate.instant('APPROVALS.GENERAL.CREATED_SUCCESSFULLY'));
        }).finally(() => {
            $scope.loading = false;
        });
    };

    $scope.updateApprovalRequestClickHandler = () => {
        $scope.loading = true;
        let modificationCalls:ng.IHttpPromise<any>[] = [];
        let approvalRequestId = ApprovalDetailsService.getPreviousRequestId();

        // Approval request need to be updated before approver can be updated
        $q((resolve, reject) => {
            if (ApprovalDetailsService.isApprovalRequestChanged()) {
                ApprovalService.UpdateApproval(approvalRequestId, ApprovalOperationName.UPDATE, ApprovalDetailsService.getApprovalRequestDTO()).then(resolve);
            } else {
                resolve();
            }
        }).then(() => {
            // Modify approvers
            if (ApprovalDetailsService.getAddedApprovers().length > 0) {
                modificationCalls.push(ApprovalService.CreateApprovers(approvalRequestId, ApprovalDetailsService.getAddedApprovers()));
            }

            if (ApprovalDetailsService.getRemovedApprovers().length > 0) {
                modificationCalls.push(ApprovalService.DeleteApprovers(approvalRequestId, ApprovalDetailsService.getRemovedApprovers()));
            }

            // Modify resources
            if (ApprovalDetailsService.getAddedResources().length > 0) {
                modificationCalls.push(ApprovalService.CreateApprovalResources(approvalRequestId, ApprovalDetailsService.getAddedResources()));
            }

            if (ApprovalDetailsService.getRemovedResources().length > 0) {
                modificationCalls.push(ApprovalService.DeleteApprovalResources(approvalRequestId, ApprovalDetailsService.getRemovedResources()));
            }

            $q.all(modificationCalls).then(() => {
                $location.url('/approval/' + approvalRequestId);
            })
        }).finally(() => {
            $scope.loading = false;
        });
    };

    $scope.getResourceIcon = (resource: ApprovalResource) => {
        if(ApprovalUtils.isWorkDocsFolder(resource.ResourceUri)) {
            return 'resource-icon-sprite-ic_folder';
        } else if (ApprovalUtils.isWorkDocsFile(resource.ResourceUri)) {
            return 'resource-icon-sprite-ic_doc_generic';
        }

        return null;
    };

    $scope.atLeastOneFileIsAttached = (resources: ApprovalResource[]) => {
        return resources.some((resource) => ApprovalUtils.isWorkDocsFile(resource.ResourceUri));
    };

    $scope.atLeastOneFolderIsAttached = (resources: ApprovalResource[]) => {
        return resources.some((resource) => ApprovalUtils.isWorkDocsFolder(resource.ResourceUri));
    };

    $scope.getAttachedFileText = (resources: ApprovalResource[]) => {
        let countOfFiles: number = resources.filter((resource) => ApprovalUtils.isWorkDocsFile(resource.ResourceUri)).length;
        if (countOfFiles > 1) {
            return $translate.instant('APPROVALS.FILE_BROWSER_PANEL.FILES_ATTACH_COUNT_PLURAL', {filesCount: countOfFiles});
        } else {
            return $translate.instant('APPROVALS.FILE_BROWSER_PANEL.FILES_ATTACH_COUNT_SINGULAR', {filesCount: countOfFiles});
        }
    };

    $scope.getAttachedFolderText = (resources: ApprovalResource[]) => {
        let countOfFolders: number = resources.filter((resource) => ApprovalUtils.isWorkDocsFolder(resource.ResourceUri)).length;
        if (countOfFolders > 1) {
            return $translate.instant('APPROVALS.FILE_BROWSER_PANEL.FOLDERS_ATTACH_COUNT_PLURAL', {foldersCount: countOfFolders});
        } else {
            return $translate.instant('APPROVALS.FILE_BROWSER_PANEL.FOLDERS_ATTACH_COUNT_SINGULAR', {foldersCount: countOfFolders});
        }
    };

    $scope.addPeopleClickHandler = () => {
        var modalHandle = $uibModal.open({
            templateUrl: './approvals/approvalLevelModal/approval_levels_modal.html',
            controller: 'ApprovalLevelsModalController',
            size: 'md',
            windowClass: 'approval-modal'
        });
        postProcessModalOpening(modalHandle);
    };

    $scope.isResourceModificationAllowed = () => {
        if ($scope.panelMode === ApprovalDetailsServiceMode.EDIT) {
            let approvalState = ApprovalDetailsService.getApproval().State;
            if (approvalState === ApprovalState.DRAFT || approvalState === ApprovalState.PUBLISHED) {
                // Above are the only two non-actioned, non-decided states
                return true;
            } else {
                return false;
            }
        }

        // default to true
        return true;
    };

    $scope.isLevelConfigEmpty = () => {
        return ApprovalDetailsService.getApprovalLevelConfigs().length === 0;
    }

    //////////////////////////////////
    // WATCHERS AND LISTENERS
    //////////////////////////////////
    $scope.$on(SignalProvider.Approval.newApproval.approvalResourceUpdated, () => {
        $scope.approvalResources = ApprovalDetailsService.getApprovalResources();
    });

    //////////////////////////////////
    // HELPER FUNCTIONS
    //////////////////////////////////
    function postProcessModalOpening(modalHandle) {
        $scope.$on("$destroy", function() {
            if (modalHandle) {
                modalHandle.close();
            }
        });
    }

    function initScope() {
        $scope.formData = {
            title: ApprovalDetailsService.getApproval().Title,
            description: ApprovalDetailsService.getApproval().Description
        };
        $scope.panelMode = ApprovalDetailsService.getServiceMode();
        $scope.approvalResources = ApprovalDetailsService.getApprovalResources();
    }
}

